module.exports = __webpack_public_path__ + "static/media/sidebargraphic.ebe1d6e4.png";